<!--
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
-->
<template>
  <div class="msg-list-box" ref="msg-list-box">
    <div class="msg-list-content" ref="msg-list-content">
      <div class="msg-list-loading" ref="msg-loading">
        <p v-if="!activeMsgItem.allLoaded"><i class="el-icon-loading"></i> 加载中</p>
        <p v-else class="loaded">已经加载完所有数据了</p>
      </div>
      <ul class="msg-list">
        <template v-for="msgItem in activeMsgItem.msgList">
          <li :key="msgItem" class="msg-item syue-clr" :class="[msgItem.fromId === fromId ? 'msg-right' : 'msg-left' ]">
            <p class="msg-head">
              <span class="name" v-if="msgItem.fromId !== fromId">{{isSupplier(activeMsgItem.toClientType) ? getCompanyName(activeMsgItem) : activeMsgItem.toName}} </span>
              <span class="time">{{msgItem.showTime || '-'}}</span>
            </p>
            <div class="msg-content">
              <!-- 纯文本 -->
              <div v-if="msgItem.msgType === 1" class="msg-text" >{{msgItem.msgBody}}</div>
              <!--附件-->
              <template v-else-if="msgItem.msgType === 2">
                <div v-if="msgItem.msgBody.isImg" class="msg-img">
                  <el-image 
                    class="img-box"
                    v-if="msgItem.msgBody.openUrl" :src="msgItem.msgBody.openUrl" 
                    :preview-src-list="[msgItem.msgBody.openUrl]">
                  </el-image>
                  <img />
                </div>
                <template  v-else >
                <div class="msg-file ">
                  <div class="msg-file-box syue-clr">
                    <p class="syue-left file-left"><img :src="msgItem.msgBody.fileIcon" /></p>
                    <div class="syue-left file-right">
                      <el-tooltip class="item" effect="dark" :content="msgItem.msgBody.originalName" placement="top-start">
                        <p class="name">{{msgItem.msgBody.originalName}}</p>
                      </el-tooltip>
                      <p class="operation" v-if="msgItem.msgBody.status !== 'send'">
                        <template v-if="msgItem.msgBody.status === 'error'">
                          <span class="error-msg syue-left">上传失败</span>
                          <a href="javascript:;" @click="resend(msgItem)" class="syue-right operation-btn">重新上传</a>
                        </template>
                        <a v-else class="download operation-btn syue-right" @click="downloadFile(msgItem.msgBody)" href="javascript:;">下载</a></p>
                    </div>
                  </div>
                  <div class="percentage syue-clr" v-if="msgItem.msgBody.status === 'send'">
                    <div class="syue-left progress-box">
                      <el-progress class="" :percentage="msgItem.msgBody.percent" :show-text="false" ></el-progress>
                    </div>
                    <span class="el-icon-error cancel" @click="removeMsg(msgItem)"></span>
                  </div>
                </div>
                </template>
              </template>
              
            </div>
          </li>
        </template>
      
      </ul>
    </div>
  </div>
</template>

<script>
  // import {offset} from '../../../../utils/dom.js'
  import Api from '../api'
  import response from '../../../../utils/response/index.js'
  import {accessorySystemType} from '../../../../common/constants'
  import Store from '../../../../common/catch-state/store'
  import Model from '../../../business/paas/store/catch-store-modules/upload'
  import download from '../../../../utils/download/index'
  import mixin from './../mixin'
  import createDOMPurify from 'dompurify'
  Store.install(Model)
  const DOMPurify = createDOMPurify(window)

  export default {
    mixins: [ mixin ],
    props: {
      activeMsgItem: {
        type: Object
      },
      toUserInfo: {
        type: Object
      },
      fromId: {},
      isShow: {
        type: Boolean
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        this.elMsgListBox = this.$refs['msg-list-box']
        this.elMsgListContent = this.$refs['msg-list-content']
        this.elMsgListBox.addEventListener('scroll', this.scroll, false)
      })
    },
    created () {
      // this.getHistoryList(this.STATUS.INIT)
    },
    data () {
      return {
        loading: false,
        DOMPurify: DOMPurify,
        contentHeight: 0,
        token: '',
        boxScrollTop: 0,
        elMsgListBox: null,
        elMsgListContent: null
      }
    },
    beforeDestroy () {
      this.elMsgListBox.removeEventListener('scroll', this.scroll)
    },
    methods: {
      scrollBottom () {
        this.updateScrollTop(this.STATUS.INIT)
      },
      removeMsg (msgItem) {
        let index = this.activeMsgItem.msgList.findIndex(item => {
          return item === msgItem
        })
        this.activeMsgItem.msgList.splice(index, 1)
      },
      async getAccessoryToken () {
        let token = await Store.paasUpload('accessoryToken').getter()
        if (token) {
          this.token = token
        } else {
          let res = await Store.paasUpload('getToken').getter()
          if (res.isOk) {
            this.token = res.content
            Store.paasUpload('accessoryToken').update(token)
          }
        }
      },
      async downloadFile (file) {
        await this.getAccessoryToken()
        const api = Api.downloadFile
        // const fileZipApi = upload.downloadFileZip
        const params = {
          system: accessorySystemType,
          fileUrl: file.filePath
        }
        download(api.type, api.url, params)
      },
      resend (msgItem) {
        // this.removeMsg(msgItem)
        // console.log(msgItem)
        // this.$emit('pretestMsg', {
        //   filePath: '',
        //   key: '',
        //   openUrl: '',
        //   originalName: file.name,
        //   uid: file.uid,
        //   id: file.id,
        //   percent: 0,
        //   status: 'send'
        // })
      },
      async getHistoryList (status) {
        const api = Api.historyList
        const pageSize = 10
        const isInit = status === this.STATUS.INIT
        // console.log(isInit && this.firstMsgId)
        if (isInit && this.firstMsgId) {
          this.scrollBottom()
          return false
        }
        this.loading = true
        // console.log(this.activeMsgItem, 'aasad')
        const res = await response(this.$http(api.type, api.url, {
          clientType: this.activeMsgItem.clientType,
          bizDataCode: this.activeMsgItem.acceptorId,
          toId: this.activeMsgItem.toId,
          applyFormCode: this.activeMsgItem.applyFormCode,
          msgId: this.firstMsgId,
          pageSize: pageSize
        }))
        this.loading = false
        if (res.isOk) {
          // 如果没有firstMsgId  需要把数组反转一下 因为是倒叙查询
          let msgList = res.content ? res.content.reverse() : []
          // 加载完成
          if (msgList.length === 0 || pageSize > msgList.length) {
            this.activeMsgItem.allLoaded = true
          }
          this.handleData(msgList)
          this.activeMsgItem.msgList.unshift(...msgList)
          this.updateHeight()
          this.$nextTick(() => {
            this.updateScrollTop(status)
          })
          this.updateMsgStatus()
          if (status === this.STATUS.INIT) {
            let list = this.activeMsgItem.msgList || []
            this.activeMsgItem.seq = list.length > 0 ? list[list.length - 1].seq : 0
            // this.scrollBottom()
            // this.activeMsgItem.frontMsgId = new Date().getTime()
          }
          // this.bgUrl = imgAddHost(res.content.url)
        }
      },
      updateHeight () {
        this.contentHeight = this.elMsgListContent.offsetHeight
        this.boxScrollTop = this.elMsgListBox.scrollTop
      },
      updateScrollTop (status) {
        let scrollTop = 0
        let contentHeight = this.elMsgListContent.offsetHeight
        // console.log(status, contentHeight, this.contentHeight, this.boxScrollTop)
        // 是不是初始化 初始化需要滚动到底部
        if (this.STATUS.INIT === status) {
          scrollTop = contentHeight - this.elMsgListBox.offsetHeight
        } else {
          scrollTop = contentHeight - this.contentHeight + this.boxScrollTop
        }
        this.elMsgListBox.scrollTop = scrollTop
      },
      scroll () {
        let scrollTop = this.elMsgListBox.scrollTop
        if (scrollTop <= 20 && !this.loading && !this.activeMsgItem.allLoaded) {
          this.getHistoryList()
        }
      }
    },
    computed: {
      firstMsgId () {
        let list = this.activeMsgItem.msgList || []
        return list.length > 0 ? list[0].msgId : null
      }
    }
  }
</script>
<style scoped lang="scss">
  .msg-list-box{
    height: 320px;
    overflow: auto;
    padding: 0px 12px 0;
    .loaded{
      color: #bbb;
      font-size: 12px;
    }
    .msg-list-content{
      padding-top: 10px;
    }
    .msg-list-loading{
      line-height: 24px;
      text-align: center;
    }
    .msg-list{
      // padding-top: 10px;
    }
    .msg-img .img-box{
      max-height: 50px;
      ::v-deep img {
        max-height: 50px;
        max-width: 300px;
        width: auto;
        height: auto;
      }
    }
    .msg-item{
      padding-bottom: 20px;
    }
    .percentage{
      width: 350px;
      box-sizing: border-box;
      display: inline-block;
      .progress-box{
        width: 330px;
        padding-top: 7px;
      }
      .cancel{
        cursor: pointer;
        color: #dddddd;
      }
    }
    .msg-file{
      width: 350px;
      display: inline-block;
    }
    .msg-file-box{
      border-radius: 5px 0px 5px 5px;
      background: #F9F9F9;
      display: inline-block;
      padding: 12px 10px;
      box-sizing: border-box;
      width: 350px;
      .file-left{
        // padding-left: 8px;
        // padding-top: 4px;
        img{
          max-width: 32px;
          max-height: 32px;
          display: block;
        }
      }
      .file-right{
        width: 286px;
        padding-left: 12px;
        padding-top: 2px;
        text-align: left;
        .name{
          max-height: 38px;
          overflow: hidden;
          line-height: 18px;
          margin-bottom: 2px;
        }
        .operation{
          font-size: 12px;
          .error-msg{
            color: #E60D0B;
          }
          .operation-btn{
            float: right;
            width: 60px;
            height: 18px;
            box-sizing: border-box;
            background: #fff;
            line-height: 16px;
            border-radius: 8px;
            border: 1px solid #1e7afc;
            text-align: center;
            color: #1e7afc;
          }
        }
      }
    }
    .msg-text{
      border-radius: 0px 5px 5px 5px;
      white-space: pre-line;
      background: #F9F9F9;
      padding: 10px;
      max-width: 400px;
      font-size: 14px;
      color: #303030;
      display: inline-block;
      text-align: left;
      word-wrap:break-word
    }
    .msg-head{
      line-height: 16px;
      color: #909090;
      font-size: 12px;
      margin-bottom: 6px;
    }
    .msg-right{
      .msg-content{
        text-align: right;
      }
      .msg-file{
        border-radius:  0 5px 5px 5px;
        .msg-file-box {
          background: #E8F1FE;
        }
      }
      .msg-text{
        background: #E8F1FE;
        border-radius: 5px 0 5px 5px;
      }
      .msg-head{
        text-align: right;
      }
    }
  }
</style>